import { createUseStyles } from 'react-jss'
import MediaQueries from '../../../styles/MediaQueries'

const useStyles = createUseStyles({
  nonFullWidthImageContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  image: {
    width: '85%',
    height: 'auto',
    maxWidth: '1440px',
    borderRadius: '4px',
    objectFit: 'cover'
  },

  [MediaQueries.Tablet]: {
    image: {
      width: '75vw'
    }
  }
})

export default useStyles
